import {
  CustomLoginData,
  resetCustomLoginDataRequestAction,
  resetCustomLoginDataSuccessAction,
  setCustomLoginDataAction,
} from './types';

export const SET_CUSTOM_LOGIN_DATA = 'SET_CUSTOM_LOGIN_DATA';
export const RESET_CUSTOM_LOGIN_DATA_REQUEST =
  'RESET_CUSTOM_LOGIN_DATA_REQUEST';
export const RESET_CUSTOM_LOGIN_DATA_SUCCESS =
  'RESET_CUSTOM_LOGIN_DATA_SUCCESS';

export const resetCustomLoginDataSuccess =
  (): resetCustomLoginDataSuccessAction => {
    return {
      type: RESET_CUSTOM_LOGIN_DATA_SUCCESS,
    };
  };

export const resetCustomLoginDataRequest =
  (): resetCustomLoginDataRequestAction => {
    return {
      type: RESET_CUSTOM_LOGIN_DATA_REQUEST,
    };
  };

export const setCustomLoginData = (
  payload: CustomLoginData,
): setCustomLoginDataAction => {
  return {
    type: SET_CUSTOM_LOGIN_DATA,
    payload,
  };
};
